import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Map, TileLayer, Marker } from 'react-leaflet';
import { divIcon } from 'leaflet';
import { connect } from 'react-redux';

import { getMapData } from '../../../Actions/MapData/getMapData';

class DataMap extends Component {
  state = {
    lat: 50.9357271,
    lng: -2.1066325,
    zoom: 10,
    showMap: false,
  }

  componentDidMount() {
    this.props.getMapData();
    setTimeout(() => {
      this.setState({ showMap: true });
    }, 200);
  }

  // componentWillReceiveProps(props) {
  //   // console.log(props);
  //   if (props.options && props.options.length === 1) {
  //     this.props.onChange(props.options[0][(props.editable ? 'id' : 'key')]);
  //     this.setState({ visible: false });
  //     return;
  //   }
  //   this.setState({ visible: true });
  // }

  clickMarker = marker => this.props.openStatisticsModal(marker);

  render() {
    const position = [this.state.lat, this.state.lng];
    if (!this.state.showMap) return null;

    return (
      <Map center={position} zoom={this.state.zoom} style={{ height: '100%' }}>
        {this.props.loading && <div style={{ color: 'red', fontSize: 40 }}>{ this.props.loading }</div> }
        <TileLayer
          url="https://1.base.maps.api.here.com/maptile/2.1/maptile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=kIZiQyTp8CG4xptYcWxI&app_code=oY3Q3RwUR-bGgK09o6o6Mw"
          attribution="Map &copy; 2019 <a href='https://developer.here.com'>HERE</a>"
          app_id="GGl6RsAqNWg6w61iw6lm"
          app_code="XYwkvlGX4AkesFd2TlWL0Q"
        />
        {typeof this.props.locations.map !== 'undefined' && this.props.locations.map(marker => (
          <Marker
            position={[marker.latitude, marker.longitude]}
            key={marker.district}
            icon={divIcon({ className: `map-mark-icon mark-bg-${marker.score ? marker.score.toFixed(0) : 0}`, html: marker.clients })}
            onClick={() => this.clickMarker(marker)}
          />
        ))}
      </Map>
    );
  }
}


DataMap.propTypes = {
  locations: PropTypes.array.isRequired,
  getMapData: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const data = {
    locations: state.mapData,
    loading: state.loading,
  };

  return data;
};

const mapDispatchToProps = dispatch => ({
  getMapData: p => dispatch(getMapData(p)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataMap);



// WEBPACK FOOTER //
// ./src/Components/Campaign/Map/index.jsx